import { CloudDownload, CloudOff, Loader2 } from 'lucide-react'
import { aquecerOffline, useOfflineReady } from '@/core/sync/offlineWarmup'
import { triggerForegroundSync } from '@/core/sync/foregroundSync'
import { useSyncStatus } from '@/core/sync/useSyncStatus'

/**
 * Linha da Home que responde à pergunta do operador antes de ir para o campo:
 * "este aparelho está pronto para trabalhar sem sinal?". Toque = baixa de novo.
 */
function quando(at: number): string {
  const d = new Date(at)
  const hora = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  const hoje = new Date().toDateString() === d.toDateString()
  return hoje ? `hoje às ${hora}` : `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} às ${hora}`
}

export function OfflineReadyLine({ temProjeto }: { temProjeto: boolean }) {
  const { estado, rodando } = useOfflineReady()
  const sync = useSyncStatus()

  const usaPd = estado.pdStatus !== 'sem_acesso'
  const marcas = [sync.lastSyncAt, usaPd ? estado.pdAt : null, temProjeto ? estado.carrAt : null].filter(
    (v): v is number => v != null,
  )
  const incompleto =
    (usaPd && estado.pdStatus !== 'ok') || (temProjeto && estado.carrStatus !== 'ok') || sync.lastSyncAt == null
  const maisAntigo = marcas.length > 0 ? Math.min(...marcas) : null

  function atualizar() {
    void triggerForegroundSync('offline-ready-tap', { ignoreCooldown: true })
    void aquecerOffline({ forcar: true })
  }

  let icone = <CloudDownload className="h-3.5 w-3.5 shrink-0 text-ok" aria-hidden />
  let texto = maisAntigo != null ? `Pronto para uso sem internet · dados de ${quando(maisAntigo)}` : 'Pronto para uso sem internet'
  let tom = 'text-on-surface-dim'
  if (rodando) {
    icone = <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-accent" aria-hidden />
    texto = 'Baixando dados para uso sem internet…'
  } else if (incompleto) {
    icone = <CloudOff className="h-3.5 w-3.5 shrink-0 text-warn" aria-hidden />
    tom = 'text-warn'
    texto = sync.online
      ? 'Dados para uso sem internet incompletos — toque para baixar'
      : 'Sem internet e dados offline incompletos — conecte antes de ir a campo'
  }

  return (
    <button
      type="button"
      onClick={atualizar}
      disabled={rodando}
      className={`w-full flex items-center gap-2 px-1 text-left text-[11px] ${tom}`}
      title={[estado.pdResumo ? `Parte diária: ${estado.pdResumo}` : null, estado.carrResumo ? `Carreteiro: ${estado.carrResumo}` : null]
        .filter(Boolean)
        .join(' | ')}
    >
      {icone}
      <span className="flex-1 min-w-0 truncate">{texto}</span>
    </button>
  )
}
